import { DirectSalesAllocationSolutionStatus } from 'components/common/types/DirectSalesAllocationSolution';
import { Color } from 'lib/Chip/Chip.types';
import { STATUS_TO_COLOR_MAPPING } from 'components/pages/Planner/PlannerSections/FiltersContent/utils.types';

export const getChipColor = (status?: DirectSalesAllocationSolutionStatus): Color => {
  if (!status) return Color.PRIMARY;

  return STATUS_TO_COLOR_MAPPING[status];
};
